import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path fill-rule="evenodd" clip-rule="evenodd" d="M12 10.25a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0 1.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9M11.92 13h.16c1.518 0 3.393 0 4.888.62.787.326 1.5.835 2.01 1.62.508.783.772 1.778.772 3.01v2.25a.75.75 0 0 1-.75.75H5a.75.75 0 0 1-.75-.75v-2.25c0-1.232.264-2.227.772-3.01.51-.785 1.223-1.294 2.01-1.62 1.495-.62 3.37-.62 4.887-.62m-5.64 3.057c-.313.483-.53 1.175-.53 2.193v1.5h12.5v-1.5c0-1.018-.217-1.71-.53-2.193-.311-.48-.757-.816-1.327-1.052-1.19-.494-2.776-.505-4.393-.505s-3.203.011-4.393.505c-.57.236-1.016.572-1.327 1.051"/>' }
  })
);